export default __webpack_public_path__ + "static/media/gcp.00ff3705.png";